<form
    [formGroup]="form"
    *yssIsLoading="subFormIsLoading$ | async">
    <app-user-select-or-create
        [form]="form"
        [selectedUser]="action.customer"></app-user-select-or-create>
    <div class="row">
        <div class="col-6 subject-select-holder">
            <label class="padded-top-gray-label">Subject for Call Back</label>
            <ng-select
                formControlName="subtypeId"
                [clearable]="false"
                [searchable]="false"
                placeholder="Select Subject">
                <ng-option
                    *ngFor="let subtype of subtypes"
                    [value]="subtype.id">
                    {{ subtype.name }}
                </ng-option>
            </ng-select>
        </div>
        <div
            class="col-6 subject-select-holder"
            *ngIf="form.controls.customerId.value">
            <label class="padded-top-gray-label">Phone (Optional)</label>
            <ys-phone-input formControlName="phoneOptional"></ys-phone-input>
        </div>
    </div>
</form>
